import { render, staticRenderFns } from "./VerticalTabItem.vue?vue&type=template&id=5e2faea0&scoped=true&"
import script from "./VerticalTabItem.vue?vue&type=script&lang=js&"
export * from "./VerticalTabItem.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTabItem.vue?vue&type=style&index=0&id=5e2faea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2faea0",
  null
  
)

export default component.exports